import { IVehicle } from '../../../../schema/Vehicle.ts';
import { getShiftStatusColors } from '../../../../utils/utils.ts';
import { VehicleBadge } from '../../../ui/Badge.tsx';

export function PlannedOperation(props: Readonly<{ vehicle: IVehicle }>) {
  return (
    <>
      <div className={'d-flex gap-3 align-items-center'}>
        <VehicleBadge vehicle={props.vehicle} />
        <p className={'card-text'}>{props.vehicle.display_identifier}</p>
        {props.vehicle.shift && (
          <span
            className={'custom-badge rounded-4 ms-auto'}
            style={getShiftStatusColors(props.vehicle.shift.status)}>
            {props.vehicle.shift.status}
          </span>
        )}
      </div>
    </>
  );
}
